import { LOCAL_STORAGE_LANG_KEY } from 'config'

export const storeLanguage = (language: string): void => {
  try {
    window.localStorage.setItem(LOCAL_STORAGE_LANG_KEY, language)
  } catch (e) {
    window.console.warn('Could not store language')
  }
}

export const getLanguage = (): string => {
  return window.localStorage.getItem(LOCAL_STORAGE_LANG_KEY) || 'en'
}
